
export const TREE_KEY_SEPARATOR = "+";